import { render, staticRenderFns } from "./OrderMenuIcons.vue?vue&type=template&id=04af1736"
import script from "./OrderMenuIcons.vue?vue&type=script&lang=js"
export * from "./OrderMenuIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports